export default __webpack_public_path__ + "static/media/PreRoleCloudFront.2662621b.md";